import { render, staticRenderFns } from "./TasanteaProductList.vue?vue&type=template&id=189c470b&scoped=true"
import script from "./TasanteaProductList.vue?vue&type=script&lang=js"
export * from "./TasanteaProductList.vue?vue&type=script&lang=js"
import style0 from "./TasanteaProductList.vue?vue&type=style&index=0&id=189c470b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c470b",
  null
  
)

export default component.exports